import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { entityDependenciesContent } from './entityDependenciesContent';
import { groupOwnershipCatalogFilter } from './groupOwnershipFilter';
import { userListCatalogFilter } from './userListFilter';

export const catalogModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    entityDependenciesContent,
    groupOwnershipCatalogFilter,
    userListCatalogFilter,
  ],
});
